import {apiUtils} from "@/utils/apiUtils";

export const basketService = {
  async addProductToBasket(productId, orderType, quantity, mealPlan = {}, options = {}) {
    try {
      const payload = {
        json: "true",
        productId,
        orderType,
        calculateOrder: true,
        quantity,
        ...options,
        ...(mealPlan?.mealPlanId && mealPlan?.groupId && {
          extendedInfos: {
            mealPlan: {
              mealPlanId: mealPlan.mealPlanId,
              groupId: mealPlan.groupId,
            },
          },
        }),
        mealPlanId: mealPlan?.mealPlanId || undefined,
        reservationDateTime: mealPlan?.reservationDateTime || undefined,
      };
      return await apiUtils.doPost("/TCPAddMenuItemToCartJ.action", payload);
    } catch (error) {
      console.error("Error adding product to basket:", error);
      throw error;
    }
  },
  async addComplexProductToBasket(productId, orderType, quantity, mealPlan = {}, options = {}) {
    try {
      const payload = {
        json: "true",
        prod: productId,
        orderType,
        calculateOrder: true,
        quantity,
        ...options,
        ...(mealPlan?.mealPlanId && mealPlan?.groupId && {
          extendedInfos: {
            mealPlan: {
              mealPlanId: mealPlan.mealPlanId,
              groupId: mealPlan.groupId,
            },
          },
        }),
        mealPlanId: mealPlan?.mealPlanId || undefined,
        reservationDateTime: mealPlan?.reservationDateTime || undefined,
      };
      return await apiUtils.doPost("/TCPAddMenuItemToCartJ.action", payload);
    } catch (error) {
      console.error("Error adding product to basket:", error);
      throw error;
    }
  },
  async editBasket(basketId, quantity, orderType, mealPlan = {}) {
    try {
      return await apiUtils.doPost('/TCPEditCartSubmitJ.action', {
        basketId: basketId,
        quantity: quantity,
        orderType: orderType,
        mealPlanId: mealPlan?.mealPlanId || undefined,
        reservationDateTime: mealPlan?.reservationDateTime || undefined,
      });
    } catch (error) {
      console.error("Error edit basket:", error);
      throw error;
    }
  },
  async removeProductFromBasket(productId, orderType, mealPlan = {}) {
      try {
        return apiUtils.doPost('/TCPRemoveMenuItemFromCartJ.action', {
            id: productId,
            orderType: orderType,
            calculateOrder: true,
            mealPlanId: mealPlan?.mealPlanId || undefined,
            reservationDateTime: mealPlan?.reservationDateTime || undefined,
          });
      } catch (error) {
          console.error("Error removing product from basket:", error);
          throw error;
      }
  },
  async removeProductFromBasketByProductId(productId, quantity, orderType, mealPlan = {}) {
    try {
      return apiUtils.doPost('/TCPRemoveMenuItemFromCartJ.action', {
        productId: productId,
        orderType: orderType,
        quantity: quantity,
        calculateOrder: true,
        mealPlanId: mealPlan?.mealPlanId || undefined,
        reservationDateTime: mealPlan?.reservationDateTime || undefined,
      });
    } catch (error) {
      console.error("Error removing product from basket:", error);
      throw error;
    }
  },
  async emptyBasket() {
    try {
      return apiUtils.doPost('/TCPEmptyBasketJ.action', {
        json: "true"
      });
    } catch (error) {
      console.error("Error emptying basket:", error);
      throw error;
    }
  }
};
